'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogProps } from '@/uiComposites/layout/Dialog.client';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { icon } from '@/uiPrimitives/media/icon';
import { ReactNode, useState } from 'react';
import { dialogButton, dialogHeader, factsheetDialog, graphSize, graphSizeContainer } from './Factsheet.css';
import { textBlock, textStyle } from '@/uiPrimitives/typography/text';
import { occupy } from '@/uiPrimitives/layout/occupy';
import { pile } from '@/uiPrimitives/layout/pile';
import { gridStack } from '@/uiPrimitives/layout/gridStack';
import { unprintable } from '@/uiPrimitives/base/printable.css';
import { translateInline } from '@/globals/translate/translateInline';
import { graphOpenIcon } from '@/uiIcons/graphOpenIcon.css';
import { graphCloseIcon } from '@/uiIcons/graphCloseIcon.css';
export const FactsheetDialog = t0 => {
  const $ = _c(25);
  const {
    children,
    title
  } = t0;
  const [opened, setOpened] = useState(false);
  const [visible, setVisible] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={classes(unprintable, occupy({
      blockSize: "capSize"
    }))}><button aria-label={translateInline({
        en: "Zoom in on the chart",
        nl: "Zoom in op de grafiek"
      })} className={classes(dialogButton)} onClick={() => {
        setOpened(true);
        setVisible(true);
      }}><i className={classes(icon({
          icon: graphOpenIcon,
          fill: "positiveBlue",
          size: "2 | h2"
        }), occupy({
          blockSize: "1 | h3"
        }), box({
          backgroundColor: "negative",
          padding: "0 | p"
        }))} /></button></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = opened && visible;
  let t3;
  let t4;
  if ($[1] !== visible) {
    t3 = () => {
      if (visible) {
        setOpened(false);
      }
    };
    t4 = () => {
      if (visible) {
        setOpened(false);
      }
    };
    $[1] = visible;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = classes(box({
      blockSize: "100%"
    }), gridStack({
      rowGap: "5 | betweenParagraphs",
      gridTemplateRows: "auto minmax(0, 1fr)"
    }));
    t6 = classes(dialogHeader, textStyle({
      capSize: "1 | h3"
    }));
    t7 = {
      gridArea: "title"
    };
    t8 = classes(textBlock({
      fontWeight: "bold",
      textAlign: "center"
    }));
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t5 = $[4];
    t6 = $[5];
    t7 = $[6];
    t8 = $[7];
  }
  let t9;
  if ($[8] !== title) {
    t9 = <h3 style={t7} className={t8}>{title}</h3>;
    $[8] = title;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div style={{
      gridArea: "close"
    }} className={classes(occupy({
      blockSize: "1 | h3"
    }))}><button aria-label={translateInline({
        en: "Close the chart",
        nl: "Sluit de grafiek"
      })} onClick={() => {
        setOpened(false);
        setVisible(false);
      }} className={classes(pile({
        justifyItems: "center",
        alignItems: "center"
      }))}><i className={classes(icon({
          icon: graphCloseIcon,
          fill: "positiveBlue",
          size: "2 | h2"
        }), occupy({
          blockSize: "1 | h3"
        }), box({
          backgroundColor: "negativeBlue",
          padding: "0 | p"
        }))} /></button></div>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t9) {
    t11 = <div className={t6}>{t9}{t10}</div>;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = classes(graphSizeContainer, pile({
      justifyItems: "center"
    }));
    t13 = classes(graphSize);
    $[13] = t12;
    $[14] = t13;
  } else {
    t12 = $[13];
    t13 = $[14];
  }
  let t14;
  if ($[15] !== children) {
    t14 = <div className={t12}><div className={t13}>{children}</div></div>;
    $[15] = children;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== t11 || $[18] !== t14) {
    t15 = <div className={t5}>{t11}{t14}</div>;
    $[17] = t11;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t15 || $[21] !== t2 || $[22] !== t3 || $[23] !== t4) {
    t16 = <>{t1}<FactsheetDialogPopup open={t2} onClose={t3} onCancel={t4}>{t15}</FactsheetDialogPopup></>;
    $[20] = t15;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  return t16;
};
const FactsheetDialogPopup = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classes(factsheetDialog, className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <Dialog {...props} className={t1}>{children}</Dialog>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};